'use client';

import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import type { CustomAddress } from '@libs/common-types';

type CustomAddressState = {
    address: CustomAddress | null;
    _hasHydrated: boolean;
};

type CustomAddressActions = {
    setAddress: (address: CustomAddress | null) => void;
    clearAddress: () => void;
    setHasHydrated: (hasHydrated: boolean) => void;
};

type CustomAddressStore = CustomAddressState & CustomAddressActions;

export const useCustomAddressStore = create<CustomAddressStore>()(
    persist(
        set => ({
            address: null,
            _hasHydrated: false,
            setAddress: address => set({ address }),
            clearAddress: () => set({ address: null }),
            setHasHydrated: hasHydrated => set({ _hasHydrated: hasHydrated }),
        }),
        {
            name: 'custom-address',
            storage: createJSONStorage(() => localStorage),
            onRehydrateStorage: () => state => state?.setHasHydrated(true),
            partialize: state => ({ address: state.address }),
        }
    )
);
